import React from 'react';
import '../icon.scss';
import './close.scss';

export default function Close() {
  return (
    <span className="icon icon--close"></span>
  );
}
